import Axios from 'axios-observable';
import {map} from "rxjs/operators";
import {Observable} from "rxjs/dist/types";
import langHelper from "@/locales/langHelper";
import {Speech} from "@/entities/Speech";
import {SpeechContainer} from "@/entities/SpeechContainer";
import {SpeechFilter} from "@/entities/SpeechFilter";
import qs from 'qs';
import {ExhibitorContainer} from "@/entities/ExhibitorContainer";
import {Exhibitor} from "@/entities/Exhibitor";
import {Theme} from "@/entities/Theme";
import {Role} from "@/entities/Role";
import {Speaker} from "@/entities/Speaker";

export class Services {

  private static readonly backendUrl = process.env.VUE_APP_BACKEND_URL;
  private static readonly project = process.env.VUE_APP_PROJECT;


  static getSpeeches(themes: string[] | null): Observable<SpeechContainer> {
    let url = `${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speeches`;

    return Axios.get<SpeechContainer>(url, {
      params: {
        themes: themes ? JSON.stringify(themes) : undefined
      }, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: "comma"});
      }
    }).pipe(map((data: any) => {
      const speeches = []
      for (const s of data.data.speeches) {
        speeches.push(new Speech(s, data.data.path));
      }
      speeches.sort(Speech.comparator);
      return new SpeechContainer(speeches);
    }));
  }

  static getSpeechFilters(themes: string[] | null): Observable<SpeechFilter> {
    let url = `${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speechFilters`;
    return Axios.get<SpeechFilter>(url, {
      params: {
        themes: themes ? JSON.stringify(themes) : undefined
      }, paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: "comma"});
      }
    }).pipe(map((data: any) => {
      return new SpeechFilter(data.data);
    }));
  }

  static getExhibitors(): Observable<ExhibitorContainer> {
    return Axios.get<ExhibitorContainer>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/exhibitors`, {
      params: {
        columns: JSON.stringify(['ID', 'NAME', 'ADRESSE', 'LAND', 'LOGO', 'PLZ', 'STADT', 'WEB', 'EMAIL', 'INFO', 'TELEFON', 'S_ORDER', 'STAND', 'HALLE'])
      },
      paramsSerializer: params => {
        return qs.stringify(params, {arrayFormat: "comma"});
      }
    }).pipe(map((data: any) => {
      let exhibitors = [];
      let themes = [];
      for (const e of data.data.exhibitors) {
        exhibitors.push(new Exhibitor(e, data.data.path));
      }
      for (const t of data.data.exhibitorThemes) {
        themes.push(new Theme(t));
      }
      themes.sort(((a: Exhibitor, b: Exhibitor) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      exhibitors.sort(((a: Exhibitor, b: Exhibitor) => {
        return a.sortOrder.localeCompare(b.sortOrder);
      }));
      return new ExhibitorContainer(exhibitors, themes);
    }));
  }


  static getSpeakers(): Observable<Speaker[]> {
    return Axios.get<Speaker[]>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speakers`)
      .pipe(map((data: any) => {
        let speakers = [];
        for (const s of data.data.speakers) {
          speakers.push(new Speaker(s, data.data.path));
        }
        speakers.sort(Speaker.comparator)
        return speakers;
      }));
  }

  static getRoles(): Observable<any> {
    return Axios.get<any>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/roles`)
      .pipe(map((data: any) => {
        let roles = [];
        for (const r of data.data) {
          roles.push(new Role(r));
        }
        roles.sort(Role.comparator);
        return roles;
      }));
  }

}
